export const DEFAULT_PAGE_SIZE = 5;

/**
 * Pure client-side pagination for already-loaded row arrays.
 *
 * Clamps the requested page into range rather than returning an empty slice — a filter that
 * shrinks the dataset while the user sits on a later page must never render a blank table.
 * Returns everything a pagination footer needs so callers don't recompute offsets by hand.
 */
export const paginate = (rows, page = 1, pageSize = DEFAULT_PAGE_SIZE) => {
  const list = Array.isArray(rows) ? rows : [];
  const totalRows = list.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
  const currentPage = Math.min(Math.max(1, page || 1), totalPages);
  const pageStart = (currentPage - 1) * pageSize;

  return {
    pageRows: list.slice(pageStart, pageStart + pageSize),
    currentPage,
    totalPages,
    pageStart,
    rangeEnd: Math.min(pageStart + pageSize, totalRows),
    totalRows,
  };
};
